module.exports = __webpack_public_path__ + "img/4-1_06.75d3076d.jpg";